import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/app/enum/role-type';
import { TariffDataServicesService } from 'src/app/services/tariff-data-services.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-product-details-popup',
  templateUrl: './product-details-popup.component.html',
  styleUrls: ['./product-details-popup.component.scss']
})
export class ProductDetailsPopupComponent implements OnInit {
  sessionDataString:any;
  roletype=RoleType;
  data = [];
  applicatioid:any;
  row:any;

  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "ServiceProviderName",
    "ProductId",
    "ProductName",
    "Cost",

  ];
  constructor(
    public dialogRef: MatDialogRef<ProductDetailsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public value: any,
    private sessionService: UserSessionService,
    private tariffDataService:TariffDataServicesService

  ) { 
    this.applicatioid=this.value.data;
    console.log(this.value);
    
  }

  ngOnInit(): void {
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );


this.tariffDataService.GetProductDetailsByApplicationId(this.applicatioid).subscribe((result)=>{
  debugger
this.data=[result];
if(this.value.title!='transfer'){
this.row={
  serviceProvider:'',
  productId:result.onceOffProductId,
  aliasName:result.onceOffProductAliceName,
  totalProductCost:result.onceOffFeeExcludingVAT
}
this.data.push(this.row)
}
console.log(this.data)
this.dataSource = new MatTableDataSource(this.data);


})
}

Close(){
this.dialogRef.close()

}


}
